import { initializeApp, getApp, getApps } from "firebase/app";
import {
  getAuth,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  onIdTokenChanged,
} from "firebase/auth";

import firebaseConfig from "config/firebase.dev.json";

// PROD
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
const auth = getAuth(app);

const logInWithEmailAndPassword = async (email, password) => {
  try {
    const { user } = await signInWithEmailAndPassword(auth, email, password);
    if (user) {
      const { claims, token } = await user.getIdTokenResult();
      if (claims.role == "Admin") {
        window.localStorage.setItem("authToken", token);
        return true;
      }
    }

    await auth.signOut();
    return false;
  } catch (err) {
    await auth.signOut();
    return false;
  }
};

const logout = () => {
  signOut(auth);
};

export {
  auth,
  logInWithEmailAndPassword,
  logout,
  onAuthStateChanged,
  onIdTokenChanged,
};
